export default __webpack_public_path__ + "4afffed5a01d0493901b5959a5394dc7.png";